// Optional translation helper.
// If REACT_APP_TRANSLATE_ENDPOINT or NEXT_PUBLIC_TRANSLATE_ENDPOINT is set,
// we will POST { text, source, target } and expect { text } back.

const EP = process.env.REACT_APP_TRANSLATE_ENDPOINT || process.env.NEXT_PUBLIC_TRANSLATE_ENDPOINT || '';

export async function translateText(text, { source = 'en', target = 'cs' } = {}) {
  try {
    if (!EP || !text || source === target) return text;
    const r = await fetch(EP, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ text, source, target })
    });
    if (!r.ok) return text;
    const j = await r.json().catch(() => ({}));
    return typeof j.text === 'string' && j.text.trim() ? j.text : text;
  } catch {
    return text;
  }
}
